var map = {
	"./Initial Class Minds.pdf": 899,
	"./PDF AULA INICIAL.pdf": 900,
	"./guia de ensino.pdf": 901,
	"./initialClass.mp4": 771,
	"./notification.mp3": 871
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 898;


//////////////////
// WEBPACK FOOTER
// ./src/assets/media ^\.\/.*$
// module id = 898
// module chunks = 2 7 38